import { Platform } from "react-native"

// https://docs.prerender.io/docs/33-overview-of-prerender-crawlers
export const IS_BOT =
  Platform.OS === "web"
    ? window.navigator.userAgent.includes("prerender")
    : false
